// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { createAsyncAction } from 'typesafe-actions';
import { ProductCard } from '../../../components/NewCard/types';
import { PaginationListResponse, SearchCondition } from '../../../types/Model';

export interface SearchOnlineCoursesRequestPayload {
  limit: number;
  page: number;
  condition: SearchCondition;
}

export type SearchOnlineCoursesSuccessPayload = PaginationListResponse<ProductCard>;

export interface SearchOnlineCoursesFailPayload {
  error: Error;
}

export const searchOnlineCoursesActions = createAsyncAction(
  'elearning/SEARCH_ONLINE_COURSES',
  'elearning/SEARCH_ONLINE_COURSES_SUCCESS',
  'elearning/SEARCH_ONLINE_COURSES_FAIL'
)<
  SearchOnlineCoursesRequestPayload,
  SearchOnlineCoursesSuccessPayload,
  SearchOnlineCoursesFailPayload
>();
